import type { TFunction } from 'i18next'

/**
 * The rail as the deposit confirmation names it, for a host that gave it no
 * name of its own. A rail this build has no copy for is named by its code
 * rather than by another rail's name.
 */
export function methodDisplayName(paymentMethod: string, t: TFunction): string {
  if (paymentMethod === 'apple_pay') {
    return t('fiat.applePay')
  }
  if (paymentMethod === 'card') {
    return t('fiat.card')
  }
  return paymentMethod
}
